import { Component, OnInit, Input, SimpleChanges, NgZone, ChangeDetectorRef } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { NotificationService } from "../_services/notification.service";
import { Router } from "@angular/router";
import { environment } from '../../environments/environment';
import { UserService } from '../_services/user.service';
import { Http, Headers } from '@angular/http';
import { Subscription } from 'rxjs';
import { config } from '../_models/apiConfig';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'userlist-item',
  templateUrl: './userlist-item.component.html',
  styleUrls: ['./userlist-item.component.css']
})
export class UserlistItemComponent implements OnInit {
  @Input() key: string;
  @Input() keyFollowWidget: string;
  @Input() keyFollowWidgetArray: any[];
  @Input() searchArray: any[];
  @Input() page: string;
  @Input() path: string;
  @Input() followPath: string;

  followings: any;
  users: any;
  userId = localStorage.getItem('currentUserId');
  currentUser: any;
  user: any;
  myFriend: any[] = [];
  request: any[] = [];
  userKey: any;
  index: any[];
  private subscription: Subscription = new Subscription();
  url: any;
  getBrand = 20;
  categoryKey: any;
  alphabet: any = environment.alphabet;
  userNotFollow: any[] = [];
  isPanding = false;
  categoryBrandRef: any = {};

  constructor(
    private zone: NgZone,
    private http: Http,
    private userService: UserService,
    private afs: AngularFirestore,
    private cd: ChangeDetectorRef,
    public notificationService: NotificationService, private router: Router) {
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.currentUser = user;
      try {
        this.myFriend = Object.values(user.following.user);
      } catch (e) { }
    }));
  }


  notMyFriends(username) {
    let array = this.myFriend.filter(data => {
      return data.username === username
    });
    return array.length == 0;
  }

  moreGetBrand() {
    let size = this.getBrand + 15;
    if (this.categoryBrandRef.query) {

    } else {
      this.subscription = this.afs.collection('brands', ref => ref.where('category', '==', this.key).orderBy('name').limit(size)).valueChanges().take(1).subscribe(data => {
        this.followings = data;
        this.getBrand += 15;
      })
    }

  }

  ngOnInit() {

  }

  navigate(username) {
    this.zone.run(() => { this.router.navigate(['/']).then(() => this.router.navigate([username])) });
  }

  getByLetter(letter, index) {
    this.categoryBrandRef = {
      query: {
        orderByChild: 'name',
        limitToFirst: this.getBrand,
        startAt: letter,
        endAt: letter + '\uf8ff'
      }
    };

    this.subscription = this.afs.collection('brands', ref => ref.where('category', '==', this.key).orderBy('name').startAt(letter).endAt(letter + "/uf8ff")).valueChanges().subscribe(data => {
      this.followings = data;

    })

  }

  allBrand() {
    this.getBrand = 20;
    this.categoryBrandRef.query = {
      limitToFirst: this.getBrand
    };

  }

  ngOnChanges(changeRecord: SimpleChanges) {

    if (changeRecord.key) {
      this.categoryKey = changeRecord.key.currentValue;
      const url = decodeURIComponent(this.router.url);
      this.url = url.split('/')[1];
      if (this.page === 'category') {

        this.subscription = this.afs.collection('brands', ref => ref.where('category', '==', changeRecord.key.currentValue).orderBy('name').limit(this.getBrand)).valueChanges().take(1).subscribe(data => {
          this.followings = data;
        })
      }

      if (this.page === 'followers') {

        this.subscription.add(this.afs.collection(this.path).doc(changeRecord.key.currentValue).collection('followEr').valueChanges()
          .subscribe(data => {
            this.followings = data;
          }));



        // this.afs.collection(this.path).doc(changeRecord.key.currentValue).collection('followEr').doc(this.userId)
        //   .ref.onSnapshot((data) => {
        //     this.followings = [data.data()];

        //   })
        // this.subscription = this.afs.collection(this.path, ref => ref.where('uniqueName', '==', changeRecord.key.currentValue)).valueChanges().take(1).subscribe(data => {
        //   let arrayFollow = [];
        //   if (data[0]['followers'])
        //     Object.entries(data[0]['followers']).forEach(follow => {

        //       arrayFollow.push(follow[1]);
        //     })
        //   this.followings = arrayFollow;
        // })
      }
      else if (this.page === 'product') {

        this.subscription = this.afs.collection('products', ref => ref.where('brand', '==', changeRecord.key.currentValue))
          .valueChanges().take(1).subscribe(data => {
            this.followings = data;

          })
      }
    }
    if (this.followPath) {

      this.subscription = this.afs.collection('users').doc(this.key).collection(this.followPath).valueChanges().subscribe(data => {
        this.followings = data;
        this.cd.markForCheck();

      })


    }
    if (changeRecord.keyFollowWidgetArray) {
      this.users = changeRecord.keyFollowWidgetArray.currentValue;
    }
  }
  getUsers(data: any) {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.subscription = this.http.post(config.live + `entity/userFollowSuggestions`,
      { followers: data, take: 1 }, { headers: headers })
      .map(res => res.json()).map(res => res.map(entity => {
        JSON.parse(entity);
        this.users.push(JSON.parse(entity));
        this.userNotFollow.push(JSON.parse(entity).username);
      })).subscribe();
  }

  randomFollow() {

    let following = this.currentUser.following ? Object.values(this.currentUser.following.user ? this.currentUser.following.user : []) : [];
    let requests = Object.values(this.currentUser.requests ? this.currentUser.requests : []);
    following.forEach(user => {
      this.userNotFollow.push(user['username']);
    });
    requests.forEach(request => {
      this.userNotFollow.push(request['username']);
    });
    this.userNotFollow.push(this.currentUser.username);
    if (this.currentUser)
      this.getUsers(this.userNotFollow);
  }

  isFollow(uniqueName, type) {
    try {
      let followings = Object.values(this.currentUser.following[type]);
      return followings.filter((following: any) => following.uniqueName == uniqueName).length != 0
    } catch (e) {
      return false;
    }
  }

  otherFollow(username) {

    if (this.userId) {
      this.afs.collection('users').ref.where('username', '==', username).get().then(keys => {
        if (keys) {
          keys.forEach(user => {
            if (!user.data().isSecret) {
              this.afs.collection('users').doc(user.id)
                .update({ followErCount: user.data().followErCount ? user.data().followErCount + 1 : 1 }).then(() => {
                  this.afs.collection('users').doc(this.userId)
                    .update({ followIngCount: this.currentUser.followIngCount ? this.currentUser.followIngCount + 1 : 1 })
                })
              this.afs.collection('users').doc(user.id).collection('followEr').doc(this.userId).set({
                firstname: this.currentUser.firstname,
                lastname: this.currentUser.lastname,
                email: this.currentUser.email ? this.currentUser.email : "",
                username: this.currentUser.username,
                profileImage: this.currentUser.profileImage,
                isSecret: this.currentUser.isSecret ? this.currentUser.isSecret : false,
                id: this.currentUser.id,
                type: "user"

              }).then(() => {
                this.afs.collection('users').doc(this.userId).collection('followIng').doc(user.id).set({
                  firstname: user.data().firstname,
                  lastname: user.data().lastname,
                  email: user.data().email ? user.data().email : "",
                  username: user.data().username,
                  profileImage: user.data().profileImage,
                  isSecret: user.data().isSecret ? user.data().isSecret : false,
                  id: user.id,
                  type: "user"

                })
                const message = {
                  body: '<span><strong>' + this.currentUser.firstname + ' ' +
                    this.currentUser.lastname + '</strong> seni takip etmeye başladı. Profilini gör!<span>',
                  innerBody: this.currentUser.firstname + ' ' + this.currentUser.lastname + ' seni takip etmeye başladı. Profilini gör!',
                  title: 'Arkadaşlık',
                  image: this.currentUser.profileImage,
                  isUnseen: true,
                  click_action: environment.domainName + "/" + this.currentUser.username,
                  action: "/" + this.currentUser.username,
                  modifyDate: Date.now()
                };
                this.notificationService.pushNotification(message, user.id);
              })
            }
            else {
              this.notificationService.pushFriendRequest(user.id, this.userId);
            }
            if (this.users) {
              this.users = this.users.filter(popUser => {
                return popUser.uniqueName != username;
              });
              this.userNotFollow.push(username);
              this.randomFollow();
            }
          })

        }
      })
    } else {
      this.router.navigate(['/auth']);
    }
  }

  async otherUnFollow(key, username) {

    await this.afs.collection('users').ref.where('username', '==', username).get().then((keys => {
      keys.forEach(user => {
        this.afs.collection('users').doc(user.id).update({ followErCount: user.data().followErCount ? user.data().followErCount - 1 : 0 });
        this.afs.collection('users').doc(user.id).collection('followEr').doc(this.userId).delete().then(() => {
          this.afs.collection('users').doc(this.userId).collection('followIng').doc(key).delete();
        })
      })
    }))
    await this.afs.collection('users').doc(this.userId)
      .update({ followIngCount: this.currentUser.followIngCount ? this.currentUser.followIngCount - 1 : 0 });
  }


  productFollow(key, type) {
    if (this.userId) {

    } else {
      this.router.navigate(['/auth']);
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/userlist-item/userlist-item.component.ts